import { FaUserShield, FaArrowRightFromBracket } from "react-icons/fa6"
import { useAdminMode, useIsAdmin } from "../hooks"

export function AdminToggle() {
  const isAdmin = useIsAdmin()
  const { inAdmin, toggleAdmin } = useAdminMode()

  if (!isAdmin) {
    return null
  }

  const label = inAdmin ? "Back to app" : "Admin area"
  const Icon = inAdmin ? FaArrowRightFromBracket : FaUserShield

  return (
    <button
      type="button"
      onClick={toggleAdmin}
      title={label}
      aria-label={label}
      aria-pressed={inAdmin}
      className="inline-flex h-9 w-9 items-center justify-center rounded-md transition-colors hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-500"
    >
      <Icon className="h-5 w-5" aria-hidden />
    </button>
  )
}
